import { useMediaQuery } from '@patrianna/shared-hooks'

const itemsPerPageMap = {
  'Top Games': { mobile: 6, tablet: 8, desktop: 12, xl: 12 },
  'New Games': { mobile: 6, tablet: 8, desktop: 12, xl: 12 },
  Slots: { mobile: 9, tablet: 12, desktop: 18, xl: 18 },
  with3DImage: { mobile: 2, tablet: 3, desktop: 4, xl: 5 },
  bingo: { mobile: 2, tablet: 4, desktop: 3, xl: 4 },
  default: { mobile: 3, tablet: 4, desktop: 6, xl: 6 },
}
const categoryConfigs = ['Top Games', 'Slots', 'New Games', 'bingo']
const DEFAULT_HORIZONTAL_PAGE_INDEX = 1

export const useHorizontalPageIndex = (category: string, gameWith3DImage?: boolean, refererPath?: string) => {
  const isMobile = useMediaQuery('xs')
  const isTablet = useMediaQuery('md')
  const isDesktop = useMediaQuery('lg')

  const getHorizontalPageIndex = (index: number) => {
    const deviceType = isMobile ? 'mobile' : isTablet ? 'tablet' : isDesktop ? 'desktop' : 'xl'
    const configKey = categoryConfigs.includes(category) ? category : gameWith3DImage ? 'with3DImage' : 'default'
    const isCalculatedHorizontalPageIndex = refererPath?.length > 0 && refererPath?.includes('home')

    return isCalculatedHorizontalPageIndex
      ? Math.ceil(index / itemsPerPageMap[configKey as keyof typeof itemsPerPageMap][deviceType])
      : DEFAULT_HORIZONTAL_PAGE_INDEX
  }

  return getHorizontalPageIndex
}
